import React from 'react'
import { Facebook, Instagram, LinkedIn, Twitter, X } from '@mui/icons-material'
import { Box, Link } from '@mui/material'
import { color } from 'framer-motion'


const CustomIcons = ({ Icon, url }) => {
  return(
    <Link href={url} target="_blank" sx={{ textDecoration: 'none' }} >
      <Icon
        sx={{
          p: { xs: 0.5, md: 1 },
          fontSize: { md: '1.1rem', xs: '1rem' },
          border: '2px solid',
          borderRadius: '50%',
          color: 'whitesmoke',
          '&:hover': { 
            bgcolor: '#242424',
            color: '#55d6aa',
            borderColor: '#55d6aa',
          }
        }} />
    </Link>
  )
}


function SocialMediaLink() {

  const socialIcons = [
    {
      icon: Facebook,
      url : "https://www.facebook.com/profile.php?id=61577974327033",
    },
    {
      icon: Instagram,
      url : "https://www.instagram.com/datapi_reaserch/",
    },
    {
      icon: LinkedIn,
      url : "https://www.linkedin.com/company/datapiresearch/",
    },
    {
      icon: X,
      url : "https://x.com/datapi_research",
    },
  ]

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: { md: 3, xs: 1 }, mx: 2 }} >
      {
        socialIcons.map((socialIcon, index) => ((
          <CustomIcons key={index} Icon={socialIcon.icon} url={socialIcon.url} />
        )))
      }
    </Box>
  )
}

export default SocialMediaLink
